import { Pipe, PipeTransform } from '@angular/core';
import { ProductCampaignCustomerType, ProductDetailViewModel } from '@models/api-search.models';

@Pipe({
    name: 'isMemberType',
    standalone: true
})
export class IsMemberTypePipe implements PipeTransform {
    transform(
        activeCampaigns: ProductDetailViewModel['activeCampaigns'],
        type: ProductCampaignCustomerType = 'AllTypes'
    ): boolean {
        return activeCampaigns?.some(campaign => campaign.assignedCustomerType === type) || false;
    }
}
